<div class="cmn-flex row gutters-lg">
    <mat-icon class="cmn-flex cmn-palette-warn-alt">warning</mat-icon>
    <h2 mat-dialog-title class="cmn-flex cmn-palette-warn-alt">Are you sure?</h2>
</div>
<mat-dialog-content class=" mat-dialog-content" id="currentTemplateName">{{name}}</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions">
    <button [mat-dialog-close]="true" mat-button id="Yes">Yes</button>
    <button [mat-dialog-close]="false" mat-button id="No">No</button>
</mat-dialog-actions>
